import React from "react";

const TextArea= ({ label, placeholder, value, onChange }) => {
    return (
        <div className="mb-3">
            <label className="form-label">{label}</label>
            <textarea
                className="form-control"
                placeholder={placeholder}
                value={value}
                onChange={onChange}
                row={3}
                wrap="soft"
                // nombre de caractères max
                
            />
        </div>
        
    ); 


}

export default TextArea ;